export default "__VITE_ASSET__DteTU1XA__"